import {environment} from '../environments/environment';

const GlobalComponent = {
  VERSION: 'v1.1.12',
  APP_VERSION: 'v1.1.12',
  APP_TIMESTAMP: '20261027',
  TOKEN_URL: `${environment.API_BASE_URL}${environment.TOKEN_VERSION}${environment.TOKEN_ENDPOINT}`,
  REFRESH_URL: `${environment.API_BASE_URL}${environment.TOKEN_VERSION}${environment.REFRESH_ENDPOINT}`,
  BASE_API_URL: `${environment.API_BASE_URL}${environment.TOKEN_VERSION}`,
  REGISTRATION_URL: `${environment.API_BASE_URL}${environment.TOKEN_VERSION}${environment.REGISTRATION_ENDPOINT}`,
  SUBMIT_OLD_URL: `${environment.API_BASE_URL}${environment.TOKEN_VERSION}${environment.SUBMIT_NO_DOCUMENT_ENDPOINT}`,
  SUBMIT_URL: `${environment.API_BASE_URL}${environment.TOKEN_VERSION}${environment.SUBMIT_ENDPOINT}`,
  VALIDATE_TOKEN_URL: `${environment.API_BASE_URL}${environment.TOKEN_VERSION}${environment.VALIDATE_ENDPOINT}`,
  AUTH_GRANT_TYPE: `${environment.AUTH_GRANT_TYPE}`,
  AUTH_CLIENT_ID: `${environment.AUTH_CLIENT_ID}`,
  AUTH_CLIENT_SECRET: `${environment.AUTH_CLIENT_SECRET}`,
  AUTH_CLIENT_SCOPE: `${environment.AUTH_CLIENT_SCOPE}`,
}
export default GlobalComponent;
